import API from './jsonapi-constants'

export const CONSTANTS = {
  ID: 'id', // 'payment' or 'delivery',
  ATTRIBUTE: {
    ID: 'order.base.address.addressid', // customer address ID (optional)
    SALUTATION: 'order.base.address.salutation', // or "mrs", "miss", "company" (optional)
    COMPANY: 'order.base.address.company', // (optional)
    VATID: 'order.base.address.vatid', // (optional)
    TITLE: 'order.base.address.title', // (optional)
    FIRSTNAME: 'order.base.address.firstname', // (optional)
    LASTNAME: 'order.base.address.lastname', // (required)
    ADDRESS1: 'order.base.address.address1', // (required)
    ADDRESS2: 'order.base.address.address2', // (optional)
    ADDRESS3: 'order.base.address.address3', // (optional)
    ADDRESS_ID: 'order.base.address.addressid', // (optional)
    POSTAL: 'order.base.address.postal', // (optional)
    CITY: 'order.base.address.city', // (required)
    STATE: 'order.base.address.state', // (optional)
    COUNTRYID: 'order.base.address.countryid', // (optional)
    LANGUAGEID: 'order.base.address.languageid', // (required by many payment gateways)
    TELEFAX: 'order.base.address.telefax', // (optional)
    EMAIL: 'order.base.address.email', // (required)
    WEBSITE: 'order.base.address.website', // (optional)
    LONGITUDE: 'order.base.address.longitude', // (optional, float value)
    LATITUDE: 'order.base.address.latitude', // (optional, float value)
  },
}

// export const REQUIRED = ['LASTNAME', 'CITY', 'LANGUAGEID', 'EMAIL']
export const REQUIRED = ['CITY', 'LANGUAGEID', 'EMAIL']

export const PATHS = {
  ID: [CONSTANTS.ID],
  SALUTATION: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.SALUTATION],
  COMPANY: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.COMPANY],
  VATID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.VATID],
  TITLE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TITLE],
  FIRSTNAME: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.FIRSTNAME],
  LASTNAME: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LASTNAME],
  ADDRESS1: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ADDRESS1],
  ADDRESS2: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ADDRESS2],
  ADDRESS3: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ADDRESS3],
  ADDRESS_ID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ADDRESS_ID],
  POSTAL: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.POSTAL],
  CITY: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CITY],
  STATE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.STATE],
  COUNTRYID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.COUNTRYID],
  LANGUAGEID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LANGUAGEID],
  TELEFAX: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TELEFAX],
  EMAIL: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.EMAIL],
  WEBSITE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.WEBSITE],
  LONGITUDE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LONGITUDE],
  LATITUDE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LATITUDE],
}

export default {
  ...CONSTANTS,
  PATHS,
  REQUIRED,
}
